import React, { useState } from "react";

interface ImageBoxProps {
  src: string;
  className?: string;
  alt?: string;
  width?: number;
  height?: number;
  fallbackText?: string;
}

export const ImageBox: React.FC<ImageBoxProps> = ({
  src,
  alt = "image",
  className = "",
  fallbackText = "画像を表示できませんでした",
}) => {
  const [error, setError] = useState(false);

  const resolveSrc = () => {
    if (!src) return "";
    if (src.startsWith("http://") || src.startsWith("https://")) return src;
    if (src.startsWith("data:image/")) return src;
    // もしsrcがBase64エンコードされた文字列であれば、data URIスキームを付与して返す
    // if (/^[A-Za-z0-9+/=]+$/.test(src)) return `data:image/png;base64,${src}`;
    return "";
  };

  const validSrc = resolveSrc();

  return (
    <figure
      className={className}
    >
      {!error && validSrc ? (
        <img
          src={validSrc}
          alt={alt}
          style={{
            maxWidth: "100%",   // 横は最大100%
            maxHeight: "100%",  // 縦も最大100%
            objectFit: "contain", // アスペクト比を保持して収める
          }}
          onError={() => setError(true)}
        />
      ) : (
        <span style={{ color: "#666", fontSize: "12px", textAlign: "center" }}>
          {fallbackText}
        </span>
      )}
    </figure>
  );
};